import type { RootState } from "@/data/store";
import { reattemptWindowEndDatePassed } from "@/features/socratic/socratic-slice/socratic-slice";

import { createDateListener } from "../timeline-listeners/create-date-listener";

/**
 * Listener for the end of the reattempt window.
 *
 * Monitors when the window closes and dispatches the action that marks it
 * passed, which is what every reattempt button gate reads.
 */
export const reattemptWindowEndDateListener = createDateListener(
  (state: RootState) => state.socratic.reattemptWindowEndDate,
  (listenerApi) => {
    listenerApi.dispatch(reattemptWindowEndDatePassed());
  }
);
